"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_1 = require("@apollo/client");
const mutation = (0, client_1.gql) `
  mutation ConnectHive($code: String!, $codeVerifier: String!, $clientId: String!, $clientSecret: String!) {
    connectHive(code: $code, codeVerifier: $codeVerifier, clientId: $clientId, clientSecret: $clientSecret) {
      _id
      hiveIntegration {
        isHiveIntegration
        isConnected
      }
    }
  }
`;
exports.default = mutation;
//# sourceMappingURL=connectHive.mutation.js.map